import React from "react";
import { motion } from "framer-motion";
import { MagneticButton, scrollToId } from "../../marketingAgency/shared";
import { INTERCEPT_HERO } from "./interceptHeroContent";

const ArrowRight = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M5 12h14" />
    <path d="m12 5 7 7-7 7" />
  </svg>
);

const lineMotion = (delay) => ({
  initial: { opacity: 0, y: 24 },
  animate: { opacity: 1, y: 0 },
  transition: { delay, duration: 0.65, ease: [0.4, 0, 0.2, 1] },
});

const InterceptHeroSection = () => (
  <section
    className="relative min-h-[70vh] flex items-center hero-mesh overflow-hidden pt-24 pb-8"
    data-testid="intercept-protocol-hero"
  >
    <div className="max-w-3xl mx-auto px-6 lg:px-8 py-24 lg:py-32 text-center">
      <motion.div
        className="inline-flex items-center space-x-3 bg-[#11151F] border border-amber-500/35 rounded-full px-4 py-2 mb-8"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.05, duration: 0.6 }}
      >
        <span className="relative flex h-1.5 w-1.5">
          <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-amber-400 opacity-60" />
          <span className="relative inline-flex rounded-full h-1.5 w-1.5 bg-amber-400" />
        </span>
        <span className="badge-mono text-amber-200/90">{INTERCEPT_HERO.badge}</span>
      </motion.div>

      <h1
        className="text-3xl sm:text-4xl md:text-5xl font-bold mb-6 leading-[1.12] tracking-tight"
        aria-label={INTERCEPT_HERO.headline}
      >
        <motion.span className="block text-partner" {...lineMotion(0.1)}>
          {INTERCEPT_HERO.headlineLine1}
        </motion.span>
        <motion.span className="block mt-1 sm:mt-2" {...lineMotion(0.25)}>
          <span className="text-partner-muted">{INTERCEPT_HERO.headlineLine2Lead}</span>
          <span className="gradient-text">{INTERCEPT_HERO.headlineLine2Accent}</span>
        </motion.span>
      </h1>

      <motion.p
        className="text-base sm:text-lg md:text-xl text-partner-muted max-w-2xl mx-auto font-body leading-relaxed mb-10"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4, duration: 0.6 }}
      >
        {INTERCEPT_HERO.subline}
      </motion.p>

      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.45, duration: 0.6 }}
      >
        <MagneticButton
          className="px-8 py-3.5 rounded-2xl font-semibold text-base inline-flex items-center gap-2"
          onClick={() => scrollToId(INTERCEPT_HERO.ctaTarget)}
        >
          <span>{INTERCEPT_HERO.cta}</span>
          <ArrowRight />
        </MagneticButton>
      </motion.div>
    </div>
  </section>
);

export default InterceptHeroSection;
